<template>
  <a-drawer
    :title="`${data.remark_name}`"
    width="800"
    :visible="visible"
    :closable="false"
    @close="onClose"
  >
    <!-- 列表 -->
    <a-table
      class="table-view"
      :data-source="dataSource"
      :columns="columns"
      :row-key="record => record.id"
      :pagination="false"
      @change="handleTableChange"
    >
      <!-- 自定义行内容 -->
      <template #bodyCell="{ column, record }">
        <!-- 上架 -->
        <template v-if="column.key === 'status'">
          <a-switch
            v-model:checked="record.status"
            checked-children="开"
            un-checked-children="关"
            @change="changeStatus($event, record, column.key)"
          />
        </template>
        <!-- 首页展示 -->
        <template v-else-if="column.key === 'home_status'">
          <a-switch
            v-model:checked="record.home_status"
            checked-children="开"
            un-checked-children="关"
            @change="changeStatus($event, record, column.key)"
          />
        </template>
        <!-- 抖音曝光 -->
        <template v-else-if="column.key === 'can_be_distributed' && record.platform_name === '抖小'">
          <a-switch
            v-model:checked="record.can_be_distributed"
            checked-children="开"
            un-checked-children="关"
            @change="changeStatus($event, record, column.key)"
          />
        </template>
        <template v-else>{{ record[column.key] || '-' }}</template>
      </template>
    </a-table>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { message } from 'ant-design-vue'
import { dramaStatusList, dramaSetStatus } from '@/api/copyright'
import Loading from '@/components/Loading'

// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 当前数据
let data = ref({})
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: '客户端',
    dataIndex: 'platform_name',
    key: 'platform_name'
  },
  {
    title: '上架',
    dataIndex: 'status',
    key: 'status'
  },
  {
    title: '首页展示',
    dataIndex: 'home_status',
    key: 'home_status'
  },
  {
    title: '抖音曝光',
    dataIndex: 'can_be_distributed',
    key: 'can_be_distributed'
  }
])

// 显示
function showDrawer (record) {
  // 清空
  dataSource.value = []
  // 记录
  data.value = record
  // 显示
  visible.value = true
  // 获取数据详情列表
  getList()
}

// 关闭
function onClose () {
  if (!isLoading.value) {
    pagination.current = 1
    visible.value = false
  }
}

// 切换状态
function changeStatus (status, record, key) {
  const params = {
    drama_ids: [data.value.id],
    platform_id: record.platform_id,
    type: key,
    status: status ? 1 : 0
  }
  dramaSetStatus(params).then(res => {
    const { code, data, msg } = res
    if (code === 0) {
      message.success('设置成功')
    } else {
      message.error(res.message || msg)
      getList()
    }
  }).catch(() => {
    message.error('设置失败')
    getList()
  })
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

// 获取数据详情列表
function getList () {
  isLoading.value = true
  const params = {
    drama_id: data.value.id,
    page: pagination.current,
    page_size: 1000
  }
  dramaStatusList(params).then(res => {
    isLoading.value = false
    const { code, data, msg } = res
    if (code === 0) {
      const list = data
      list.forEach(item => {
        item.status = item.status ? true : false
        item.home_status = item.home_status ? true : false
        item.can_be_distributed = item.can_be_distributed ? true : false
      })
      dataSource.value = data
      // pagination.total = data.total
    } else {
      message.error(res.message || msg)
    }
  })
}

// 抛出
defineExpose({
  showDrawer
})

</script>

<style scoped>
.tool-view {
  width: 100%;
  display: flex;
  align-items: center;
}
.tool-title:not(:first-child) {
  margin-left: 16px;
}

</style>